/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentMessageTemplate model module.
 * @module model/AgentMessageTemplate
 * @version 1.0.0
 */
class AgentMessageTemplate {
    /**
     * Constructs a new <code>AgentMessageTemplate</code>.
     * @alias module:model/AgentMessageTemplate
     */
    constructor() { 
        
        AgentMessageTemplate.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentMessageTemplate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentMessageTemplate} obj Optional instance to populate.
     * @return {module:model/AgentMessageTemplate} The populated <code>AgentMessageTemplate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentMessageTemplate();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('template_type')) {
                obj['template_type'] = ApiClient.convertToType(data['template_type'], 'String');
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
            if (data.hasOwnProperty('usage_count')) {
                obj['usage_count'] = ApiClient.convertToType(data['usage_count'], 'Number');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentMessageTemplate</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentMessageTemplate</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['template_type'] && !(typeof data['template_type'] === 'string' || data['template_type'] instanceof String)) {
            throw new Error("Expected the field `template_type` to be a primitive type in the JSON string but got " + data['template_type']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }

        return true;
    }


}



/**
 * テンプレートID
 * @member {Number} id
 */
AgentMessageTemplate.prototype['id'] = undefined;

/**
 * エージェントID
 * @member {Number} agent_id
 */
AgentMessageTemplate.prototype['agent_id'] = undefined;

/**
 * テンプレートタイトル
 * @member {String} title
 */
AgentMessageTemplate.prototype['title'] = undefined;

/**
 * テンプレート内容
 * @member {String} content
 */
AgentMessageTemplate.prototype['content'] = undefined;

/**
 * テンプレートタイプ
 * @member {module:model/AgentMessageTemplate.TemplateTypeEnum} template_type
 */
AgentMessageTemplate.prototype['template_type'] = undefined;

/**
 * 表示順
 * @member {Number} order
 */
AgentMessageTemplate.prototype['order'] = undefined;

/**
 * 使用回数
 * @member {Number} usage_count
 */
AgentMessageTemplate.prototype['usage_count'] = undefined;

/**
 * @member {String} short_appeal_message
 */
AgentMessageTemplate.prototype['short_appeal_message'] = undefined;

/**
 * 作成日時
 * @member {Date} created_at
 */
AgentMessageTemplate.prototype['created_at'] = undefined;

/**
 * 更新日時
 * @member {Date} updated_at
 */
AgentMessageTemplate.prototype['updated_at'] = undefined;





/**
 * Allowed values for the <code>template_type</code> property.
 * @enum {String}
 * @readonly
 */
AgentMessageTemplate['TemplateTypeEnum'] = {

    /**
     * value: "investment"
     * @const
     */
    "investment": "investment",

    /**
     * value: "assessment"
     * @const
     */
    "assessment": "assessment"
};



export default AgentMessageTemplate;

